import React, { useState, useEffect } from "react";
import { Col, Container, Row, Button, Spinner, Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import SingleDetail from "../../components/singleDetail/SingleDetail";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { FiEdit3, FiArrowLeft } from "react-icons/fi";

const LeasePurposeItem = () => {
  const navigate = useNavigate();
  const { Id } = useParams();
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user ?? authState;
  const token = loggedInUser?.refreshToken || authState?.refreshToken || loggedInUser?.token || authState?.token;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}/lease-purpose/${Id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const resData = response.data;
        const dataObj =
          resData?.leasePurpose ||
          resData?.data ||
          resData?.lease_purpose ||
          (typeof resData === "object" ? resData : null);

        setDetails(dataObj);
      } catch (error) {
        console.error("Error fetching lease purpose details:", error);
        showToast("Error fetching lease purpose details.", { type: "error" });
      } finally {
        setLoading(false);
      }
    };

    if (Id) {
      fetchDetails();
    }
  }, [Id, baseUrl, token]);

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Lease Purpose", link: "/lease-purpose" },
    { label: details?.name || Id, link: `/lease-purpose/${Id}`, active: true },
  ];

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          <BreadCrumb items={breadcrumbItems} />
          <Row>
            <Col lg={12} md={12} sm={12}>
              <SingleDetailHeader
                header={details?.name || "Lease Purpose Details"}
                description="View information about this lease purpose."
              />

              <Card className="shadow-sm border rounded-3 p-4 mt-3">
                <Card.Body>
                  <SingleDetail label="ID" userDetail={details?.id || Id} />
                  <SingleDetail label="Name" userDetail={details?.name || "-"} />
                  <SingleDetail label="Description" userDetail={details?.description || "-"} />

                  <div className="d-flex justify-content-end gap-2 mt-4">
                    <Button variant="secondary" onClick={() => navigate("/lease-purpose")}>
                      <FiArrowLeft className="me-1" /> Back
                    </Button>
                    <Link to={`/lease-purpose/${Id}/edit`} className="btn btn-primary">
                      <FiEdit3 className="me-1" /> Edit
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default LeasePurposeItem;
